import { DonutChartComponent } from './donut-chart.component';

export const DONUTCHART_DECLARATIONS: any[] = [DonutChartComponent];